import { Box, HStack, IconButton, Spacer, Spinner } from '@cardboard-ui/react';
import { t } from '@lingui/macro';
import React from 'react';
import { CheckIcon, TrashIcon } from 'components/icons';
import { FileIcon } from 'components/icons/FileIcon';

export const AttachmentUploadItem = ({
  mimeType,
  name,
  uploading,
  handleRemove,
}: {
  mimeType: string | undefined;
  name: string;
  uploading: boolean;
  handleRemove?: () => void;
}) => {
  return (
    <HStack>
      <FileIcon mimeType={mimeType} />
      <Box>{name}</Box>
      <Spacer />
      {uploading ? <Spinner size="sm" /> : <CheckIcon />}
      {!uploading && handleRemove && (
        <IconButton
          aria-label={t`Remove`}
          icon={<TrashIcon />}
          onClick={handleRemove}
        />
      )}
    </HStack>
  );
};
